// relative import to avoid importing custom module named redux
import { combineReducers } from '../../node_modules/redux';

import messages from './messages';
import agents from './agents';
import channels from './channels';
import accounts from './accounts';
import appState from './appState';
import bot_tags from './bot_tags';
import tags from './tags';
import integrations from './integrations';
import searchResults from './search_results';
import groups from './groups';
import field_mappings from './field_mappings';
import fields from './fields';
import location from './location';
import agent_teams from './agent_teams';
import teams from './teams';
import contact_tags from './contact_tags';
import workflows from './workflows';
import typing_status from './typing';
import recurring_exports from './recurring_exports';
import saved_replies from './saved_replies';
import stats from './stats';
import skills from './skills';
import visible_agents from './visible_agents';
import ui from './ui';
import data_sources from './data_sources';

import conversationsRoute from 'routes/conversations/reducer';
import contactsRoute from 'routes/contacts/reducer';
import statsRoute from 'routes/stats/reducer';
import botsRoute from 'routes/bots/reducer';

export default combineReducers({
  accounts,
  agent_teams,
  agents,
  appState,
  bot_tags,
  botsRoute,
  channels,
  contact_tags,
  contactsRoute,
  conversationsRoute,
  data_sources,
  field_mappings,
  fields,
  groups,
  integrations,
  location,
  messages,
  recurring_exports,
  saved_replies,
  searchResults,
  skills,
  stats,
  statsRoute,
  tags,
  teams,
  typing_status,
  ui,
  visible_agents,
  workflows,
});
